document.addEventListener('DOMContentLoaded', () => {
  const revealBlocks = document.querySelectorAll('.wp-block-digivibe-reveal');

  revealBlocks.forEach((block, index) => {
    const button = block.querySelector('.dv-reveal__button');
    const content = block.querySelector('.dv-reveal__content');

    if (!button || !content) {
      return;
    }

    const contentId = `dv-reveal-content-${index}`;
    const openLabel = button.dataset.openLabel || button.textContent;
    const closeLabel = button.dataset.closeLabel || 'Show less';

    content.id = contentId;
    button.type = 'button';
    button.setAttribute('aria-controls', contentId);

    button.addEventListener('click', () => {
      const isOpen = block.classList.toggle('is-open');

      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      content.hidden = !isOpen;
      button.textContent = isOpen ? closeLabel : openLabel;
    });
  });
});
